import { PlusCircledIcon } from "@radix-ui/react-icons";
import { Store } from "lucide-react";

import Logo from "src/components/icon/Logo";
import { PaywallDialog } from "src/components/PaywallDialog/PaywallDialog";
import { Button } from "src/components/ui/button";
import { requestJoinDemoStore } from "src/lib/demoStore";

const EmptyState = () => {
  return (
    <div className="flex h-full w-full items-center justify-center px-4 py-10 text-center">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center">
        <Logo className="h-14" />

        <div className="mt-5 max-w-2xl space-y-3">
          <h1 className="text-foreground text-2xl leading-tight font-semibold tracking-tight sm:text-3xl">
            Connect your store or try the demo
          </h1>
          <p className="text-muted-foreground text-sm leading-6 sm:text-base">
            Connect Shopify to start analyzing your own store, or open a demo
            workspace and see the dashboards and metrics immediately.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <PaywallDialog
            onClick={() => {
              window.open(process.env.SHOPIFY_LISTING_URL, "_blank");
            }}
          >
            <Button size="lg">
              <PlusCircledIcon className="size-5" />
              Add Store
            </Button>
          </PaywallDialog>
          <Button
            variant="outline"
            size="lg"
            onClick={() => requestJoinDemoStore()}
          >
            <Store className="size-5" />
            Try Demo Store
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
